import {ResponseStatus} from "../../actions/types";
import {PayloadAction} from "@reduxjs/toolkit";
import {PagingDataModel} from "../../pages/shared/models/paging-data.model";
import {UserUploadsSliceData} from "../slices/user-uploads.slice";

export function handleGetMyUploads(state: UserUploadsSliceData, status: ResponseStatus, payload: any): void {
    switch (status) {
        case ResponseStatus.PENDING:
            state.isLoading = true;
            state.errors = payload?.errors;

            break;
        case ResponseStatus.FAIL:
            state.isLoading = false;
            state.errors = payload?.errors;

            break;
        case ResponseStatus.SUCCESS:
            state.isLoading = false;

            state.myUploadsData = payload && payload.myUploads
                ? {...payload.myUploads}
                : {uploads: [], totalItems: 0, currentPage: 0, pageSize: 10}

            break;
    }
}

export function onPaginationChange (state: UserUploadsSliceData, action: PayloadAction<PagingDataModel>): void {
    state.myUploadsData.pageSize = action.payload.pageSize;
    state.myUploadsData.currentPage = action.payload.currentPage;
}